import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

interface CategoryCount {
  category_id: string;
  count: number;
}

export function useCategoryCounts() {
  return useQuery({
    queryKey: ['category-counts'],
    queryFn: async () => {
      // Get tool_categories with their category_ids for approved tools only
      const { data, error } = await supabase
        .from('tool_categories')
        .select(`
          category_id,
          tools!inner(status)
        `)
        .eq('tools.status', 'approved');

      if (error) throw error;

      // Count tools per category
      const counts: Record<string, number> = {};
      (data || []).forEach((tc: any) => {
        counts[tc.category_id] = (counts[tc.category_id] || 0) + 1;
      });

      return counts;
    }
  });
}
